<div class="content md3-surface grid-1-auto case-creator">
  <div *ngIf="!wfConfig.isLoading" class="content layout-auto-1">
    <!--Workflow Timeline-->
    <div class="md3-card-on-surface app-space-bottom wf-timeline">
      <div class="grid-auto-1-auto">
        <i (click)="navigateLeft()" [tooltip]="getRessource('Back')" flow="right" style="font-size: medium" class="fal fa-arrow-left app-drawer-icon  wf-navigate"></i>
        <div class="grid cols-{{workflow.length}}  wf-grid">
          <ng-container *ngFor="let wf of workflow; index as i">
            <div class="stack-center">
              <i *ngIf="wf.progress === 100" class="fa-duotone fa-solid fa-circle-check  wf-icon-full"></i>
              <div *ngIf="wf.progress !== 100" class="wf-navigation-point"></div>
              <div *ngIf="i > 0" class="wf-line-connector"></div>
              <div *ngIf="i < workflow.length" class="wf-line-progress"
                   [ngStyle]="{'width': wf.progress + '%', 'background-color': wf.progress === 100 ? 'var(--c-green-400)' : 'var(--c-light-400)'}">
              </div>
              <span [ngStyle]="{'color': wfConfig.selectedWorkflowIndex === i ? 'var(--c-dark-400)' : 'var(--c-neutral-800)',
                        'font-weight': wfConfig.selectedWorkflowIndex === i ? '500' : '400' }">
                  {{wf.navigationName}}
              </span>
            </div>
          </ng-container>
        </div>
        <i (click)="navigateRight()" [tooltip]="getRessource('Next')" flow="left" style="font-size: medium" class="fal fa-arrow-right app-drawer-icon  wf-navigate"></i>
      </div>
    </div>
    <!--Content & Media DropZone-->
    <div class="content grid-1-auto">
      <!--Main Content-->
      <div class="content md3-card-on-surface">
        <!--Start-->
        <div *ngIf="wfConfig.selectedWorkflowIndex === 0 && workflow[0] as wf" class="content">
          <div class="wf-content">
            <div class="wf-header">
              <h1>{{wf.headerText}}</h1>
              <p>Willkommen zur Auftragsanlage!</p>
              <p>Hier erfassen Sie alle relevanten Informationen rund um den Schaden und können die erforderlichen Unterlagen direkt hochladen. Dadurch wird eine strukturierte Vorbereitung des Auftrags sichergestellt, die den weiteren Prozess erleichtert.
              </p>
              <p>Die Anlage oder Bearbeitung dient dazu, einen Entwurf zu erstellen, der nach Abschluss aller Schritte überprüft und finalisiert werden kann. So stellen Sie sicher, dass der Auftrag vollständig und korrekt für den nächsten Bearbeitungsschritt bereitsteht.
              </p>
            </div>
          </div>
        </div>
        <!--Auftraggeber-->
        <div *ngIf="wfConfig.selectedWorkflowIndex === 1 && workflow[1] as wf" class="content">
          <div class="content wf-content">
            <!--Header-->
            <div class="wf-header">
              <h1>{{wf.headerText}}</h1>
              <p>In diesem Schritt wählen Sie einen Auftraggeber und anschließend die passende Versicherung aus. Optional können Sie einen Ansprechpartner hinzufügen, der zum gleichen Auftraggeber gehört.</p>
              <p>Geben Sie außerdem die Schaden-, Bearbeitungs- sowie die Versicherungsnummer an.</p>
            </div>
            <!--OE Grid-->
            <div class="grid-auto-1-auto">
              <!-- Auftraggeber -->
              <div>
                <p style="position: relative">
                  <span class="c-red" style="overflow: visible; position: absolute; left: -26px; top: 18px;">*</span>
                  <label class="md-input width-auto">{{enumSvc.getFieldCaption("Auftrag", "au_oeID_Auftraggeber")}}</label>
                </p>
              </div>
              <ng-container *ngIf="showTop3Auftraggeber">
                <span class="wf-input spawn-evenly" *ngIf="TOP_3_LIST.length > 0">
                  <ng-container *ngFor="let OE of TOP_3_LIST">
                    <div  class="wf-top3-item"
                          tabindex="0"
                          [tooltip]="OE?.Top3Name" flow="left" style="font-size: medium"
                          (keydown.enter)="changeOE('au_oeID_Auftraggeber', OE)"
                          (click)="changeOE('au_oeID_Auftraggeber', OE)">
                      {{OE?.oeNPraefix}}
                    </div>
                  </ng-container>
                </span>
              </ng-container>
              <ng-container *ngIf="!showTop3Auftraggeber">
                <span class="md-input">
                    <app-exg-type-ahead-input
                      [listdisplay]="'AnzeigeName'"
                      [listCall]="'OER_List_CrmRolle_Parent_OETyp'"
                      [pObj]="{ oe_CrmRolle: 4, oe_enmIdent_OETyp: 1,
                                parentOEID: '00000000-0000-0000-0000-000000000000' }"
                      [searchPlaceholder]="getRessource('SearchAG')"
                      [insertReturnValue]="insertedValuesOEs['au_oeID_Auftraggeber']"
                      (choseObj)="changeOE('au_oeID_Auftraggeber', $event)"
                      (deleteChosenObj)="deleteOE('au_oeID_Auftraggeber')"
                    ></app-exg-type-ahead-input>
              </span>
              </ng-container>
              <span class="wf-input">
                  <i *ngIf="showTop3Auftraggeber"
                     class="fad fa-search search-filter-action" style="margin-top: 0; font-size: medium" tabindex="0"
                     [tooltip]="getRessource('ShowSearch')" flow="left"
                     (keydown.enter)="showTop3Auftraggeber = false"
                     (click)="showTop3Auftraggeber = false"></i>
                  <i *ngIf="!showTop3Auftraggeber"
                     class="fad fa-ranking-star search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                     [tooltip]="getRessource('ShowTop3')" flow="left"
                     (keydown.enter)="deleteOE('au_oeID_Auftraggeber'); showTop3Auftraggeber = true"
                     (click)="deleteOE('au_oeID_Auftraggeber'); showTop3Auftraggeber = true"></i>
                  <i class="fad fa-magnifying-glass-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                     [tooltip]="getRessource('SearchAdv')" flow="left"
                     (keydown.enter)="searchOEAdvanced('au_oeID_Auftraggeber', '00000000-0000-0000-0000-000000000000', 4, 1)"
                     (click)="searchOEAdvanced('au_oeID_Auftraggeber', '00000000-0000-0000-0000-000000000000', 4, 1)"></i>
                  <i class="fad fa-circle-plus search-filter-action" style="margin-top: 0; font-size: medium" tabindex="0"
                     [tooltip]="getRessource('AddOE')" flow="left"
                     (keydown.enter)="openNewOEModal('au_oeID_Auftraggeber', '00000000-0000-0000-0000-000000000000', true)"
                     (click)="openNewOEModal('au_oeID_Auftraggeber', '00000000-0000-0000-0000-000000000000', true)"></i>
                </span>
              <!-- Ansprechpartner -->
              <p @slideInOut *ngIf="wf.data.au_oeID_Auftraggeber !== '00000000-0000-0000-0000-000000000000'">
                <label class="md-input width-auto">
                  {{enumSvc.getFieldCaption("Auftrag", "au_oeId_Ansprechpartner")}}
                  <i class="fa-fw fal" [ngClass]="wf.data.au_oeId_Ansprechpartner !== '00000000-0000-0000-0000-000000000000' ? 'fa-check' : 'fa-times'"></i>
                </label>
              </p>
              <span class="md-input" @slideInOut *ngIf="wf.data.au_oeID_Auftraggeber !== '00000000-0000-0000-0000-000000000000'">
                  <app-exg-type-ahead-input
                    [listdisplay]="'AnzeigeName'"
                    [searchPlaceholder]="getRessource('SearchAnAG')"
                    [listCall]="'OER_List_CrmRolle_Parent_OETyp'"
                    [pObj]="{ oe_CrmRolle: 0, oe_enmIdent_OETyp: 0,
                                parentOEID: wf.data.au_oeID_Auftraggeber }"
                    [insertReturnValue]="insertedValuesOEs['au_oeId_Ansprechpartner']"
                    (choseObj)="changeOE('au_oeId_Ansprechpartner', $event)"
                    (deleteChosenObj)="deleteOE('au_oeId_Ansprechpartner')"
                  ></app-exg-type-ahead-input>
                </span>
              <span @slideInOut *ngIf="wf.data.au_oeID_Auftraggeber !== '00000000-0000-0000-0000-000000000000'"
                    class="wf-input grid-1-auto">

                <i class="fad fa-magnifying-glass-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                   [tooltip]="getRessource('SearchAdv')" flow="left"
                   (keydown.enter)="searchOEAdvanced('au_oeId_Ansprechpartner', wf.data.au_oeID_Auftraggeber)"
                   (click)="searchOEAdvanced('au_oeId_Ansprechpartner', wf.data.au_oeID_Auftraggeber)"></i>

                  <i class="fad fa-circle-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                     [tooltip]="getRessource('AddOE')" flow="left"
                     (keydown.enter)="openNewOEModal('au_oeId_Ansprechpartner', wf.data.au_oeID_Auftraggeber, false)"
                     (click)="openNewOEModal('au_oeId_Ansprechpartner', wf.data.au_oeID_Auftraggeber, false)"></i>
                </span>
              <!--Versicherung anders Switch-->
              <div class="wf-span-layout">
                <exg-checkbox
                  class="md-check-reverse typo-small"
                  tabindex="0"
                  (keydown.enter)="versIsDifferent = !versIsDifferent"
                  [(ngModel)]="versIsDifferent"
                  [caption]="getRessource('VersDiff')"
                  type="switch">
                </exg-checkbox>
              </div>
              <!-- Versicherung -->
              <p @slideInOut *ngIf="versIsDifferent">
                <label class="md-input width-auto">{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_Versicherung")}}
                  <i class="fa-fw fal" [ngClass]="wf.data.aue_oeID_Versicherung !== '00000000-0000-0000-0000-000000000000' ? 'fa-check' : 'fa-times'"></i>
                </label>
              </p>
              <span @slideInOut *ngIf="versIsDifferent" class="md-input">
                    <app-exg-type-ahead-input
                      [listdisplay]="'AnzeigeName'"
                      [searchPlaceholder]="getRessource('SearchVers')"
                      [listCall]="'OER_List_CrmRolle_Parent_OETyp'"
                      [pObj]="{ oe_CrmRolle: 4, oe_enmIdent_OETyp: 1,
                                parentOEID: '00000000-0000-0000-0000-000000000000' }"
                      [insertReturnValue]="insertedValuesOEs['aue_oeID_Versicherung']"
                      (choseObj)="changeOE('aue_oeID_Versicherung', $event)"
                      (deleteChosenObj)="deleteOE('aue_oeID_Versicherung')"
                    ></app-exg-type-ahead-input>
                  </span>
              <span  @slideInOut *ngIf="versIsDifferent"
                     class="wf-input">

                <i class="fad fa-magnifying-glass-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                   [tooltip]="getRessource('SearchAdv')" flow="left"
                   (keydown.enter)="searchOEAdvanced('aue_oeID_Versicherung', '00000000-0000-0000-0000-000000000000', 4, 1)"
                   (click)="searchOEAdvanced('aue_oeID_Versicherung', '00000000-0000-0000-0000-000000000000', 4, 1)"></i>

                <i class="fad fa-circle-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                   [tooltip]="getRessource('AddOE')" flow="left"
                   (keydown.enter)="openNewOEModal('aue_oeID_Versicherung', '00000000-0000-0000-0000-000000000000', true)"
                   (click)="openNewOEModal('aue_oeID_Versicherung', '00000000-0000-0000-0000-000000000000', true)"></i>
              </span>
              <!--Versicherung Ansprechpartner-->
              <p @slideInOut *ngIf="versIsDifferent && wf.data.aue_oeID_Versicherung !== '00000000-0000-0000-0000-000000000000'" >
                <label class="md-input width-auto">
                  {{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_Versicherung_AnspPtnr")}}
                  <i class="fa-fw fal" [ngClass]="wf.data.aue_oeID_Versicherung_AnspPtnr !== '00000000-0000-0000-0000-000000000000' ? 'fa-check' : 'fa-times'"></i>
                </label>
              </p>
              <span @slideInOut *ngIf="versIsDifferent && wf.data.aue_oeID_Versicherung !== '00000000-0000-0000-0000-000000000000'" class="md-input" >
                  <app-exg-type-ahead-input
                    [listdisplay]="'AnzeigeName'"
                    [searchPlaceholder]="getRessource('SearchAnVers')"
                    [isLocked]="workflow[1].data.aue_oeID_Versicherung === '00000000-0000-0000-0000-000000000000'"
                    [listCall]="'OER_List_CrmRolle_Parent_OETyp'"
                    [pObj]="{ oe_CrmRolle: 0, oe_enmIdent_OETyp: 0,
                              parentOEID: workflow[1].data.aue_oeID_Versicherung }"
                    [insertReturnValue]="insertedValuesOEs['aue_oeID_Versicherung_AnspPtnr']"
                    (choseObj)="changeOE('aue_oeID_Versicherung_AnspPtnr', $event)"
                    (deleteChosenObj)="deleteOE('aue_oeID_Versicherung_AnspPtnr')"
                  ></app-exg-type-ahead-input>
                </span>
              <span @slideInOut *ngIf="versIsDifferent && wf.data.aue_oeID_Versicherung !== '00000000-0000-0000-0000-000000000000'" class="wf-input grid-1-auto">


                <i class="fad fa-magnifying-glass-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                   [tooltip]="getRessource('SearchAdv')" flow="left"
                   (keydown.enter)="searchOEAdvanced('aue_oeID_Versicherung_AnspPtnr', workflow[1].data.aue_oeID_Versicherung)"
                   (click)="searchOEAdvanced('aue_oeID_Versicherung_AnspPtnr', workflow[1].data.aue_oeID_Versicherung)"></i>

                  <i class="fad fa-circle-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                     [tooltip]="getRessource('AddOE')" flow="left"
                     (keydown.enter)="openNewOEModal('aue_oeID_Versicherung_AnspPtnr', workflow[1].data.aue_oeID_Versicherung, false)"
                     (click)="openNewOEModal('aue_oeID_Versicherung_AnspPtnr', workflow[1].data.aue_oeID_Versicherung, false)"></i>
                </span>
            </div>
            <!--Inputs Grid-->
            <div class="grid cols-2">
              <!--Bearbeitungsnummer-->
              <exg-input [caption]="enumSvc.getFieldCaption('Auftrag', 'auMdtOKZ')" name="AuMdtOKZ2" [minlength]="6"
                         (ngModelChange)="changeDataFromInput('auMdtOKZ', $event, workflow[1])"
                         [ngModel]="workflow[1].data.auMdtOKZ" type="text" ></exg-input>
              <!--Schadennummer-->
              <exg-input [required]="true"
                [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')" name="aueSchadenNr2"
                         (ngModelChange)="changeDataFromInput('aueSchadenNr', $event, workflow[1])"
                         [ngModel]="workflow[1].data.aueSchadenNr" type="text" ></exg-input>
              <!--Versicherungsnummer-->
              <exg-input [caption]="enumSvc.getFieldCaption('Auftrag', 'auOKZ')" name="AuOKZ2"
                         (ngModelChange)="changeDataFromInput('auOKZ', $event, workflow[1])"
                         [ngModel]="workflow[1].data.auOKZ" type="text" ></exg-input>
            </div>
          </div>
        </div>
        <!--Auftragdetails-->
        <div *ngIf="wfConfig.selectedWorkflowIndex === 2 && workflow[2] as wf" class="content">
          <div class="content wf-content">
            <!--Header-->
            <div class="wf-header">
              <h1>{{wf.headerText}}</h1>
              <p>Erfassen Sie hier die spezifischen Details des Auftrags. Beschreiben Sie Besonderheiten oder relevante Informationen, um den Auftrag genauer zu spezifizieren.</p>
              <p>Ergänzen Sie zudem die erforderlichen Angaben zu den entsprechenden Leistungsgegenständen, um eine klare Grundlage für die weitere Bearbeitung zu schaffen.</p>
            </div>
            <div class="grid cols-12">
              <!--Auftragstyp-->
              <app-exg-select-enumeration #VCauTyp
                                          [value]="wf.data.au_enmIdent_AuftragTyp"
                                          (valueChange)="changeDataFromInput('au_enmIdent_AuftragTyp', $event, wf)"
                                          [caption]="enumSvc.getFieldCaption('Auftrag', 'au_enmIdent_AuftragTyp')"
                                          enumerationName="AuftragTyp"
                                          class="span-12">
              </app-exg-select-enumeration>
              <!--Auftragsbeschreibung textarea-->
              <exg-textarea class="span-6" [caption]="enumSvc.getFieldCaption('Auftrag', 'auBeschreibung')"
                            [ngModel]="wf.data.auBeschreibung" name="auBeschreibung"
                            (ngModelChange)="changeDataFromInput('auBeschreibung', $event, wf)"
              ></exg-textarea>
              <!--Auftragsdatum-->
              <exg-input [ngModel]="wf.data.aueAuftragsdatum"
                         (ngModelChange)="changeDataFromInput('aueAuftragsdatum', $event, wf)"
                         [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aueAuftragsdatum')"
                         name="AuftragsDatum" class="span-6"
                         type="date" [isEpoch]="true">
              </exg-input>
              <!--Leistungsgegenstand Multiple Choice-->
              <div class="md-input span-12"><label style="position: absolute;
                                                          top: 0;
                                                          opacity: 1;
                                                          font-size: smaller;
                                                          transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                                                          z-index: 0;">
                {{enumSvc.getFieldCaption('AuftragE_EIS','aueLeistungsgegenstand')}}
              </label></div>

              <!--Leistungsgegenstand-->
              <ng-container *ngFor="let enm of aueLeistungsgegenstandEnmList">
                <exg-switch [(ngModel)]="enm.enmValue"
                            (ngModelChange)="computeAueLeistungsgegenstand()"
                            caption="{{enm.enmText}}"
                            class="span-6"></exg-switch>
              </ng-container>
            </div>
          </div>
        </div>
        <!--Schadendaten-->
        <div *ngIf="wfConfig.selectedWorkflowIndex === 3 && workflow[3] as wf" class="content">
          <div class="content wf-content">
            <!--Header-->
            <div class="wf-header">
              <h1>{{wf.headerText}}</h1>
              <p>Geben Sie hier alle relevanten Informationen zur Versicherung und zum Schaden an. Dazu gehören die Versicherungsgesellschaft und der Ansprechpartner, der Schadenort, das Schadendatum sowie die Versicherungsart.</p>
              <p>Ergänzen Sie außerdem Angaben zur Schadenart und zur Ursache.</p>
            </div>
            <!--OE & Adr Grid-->
            <div class="grid-auto-1-auto">
              <!--Versicherngsnehmer-->
              <p>
                <label class="md-input width-auto">{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_VN")}}
                  <i class="fa-fw fal" [ngClass]="wf.data.aue_oeID_VN !== '00000000-0000-0000-0000-000000000000' ? 'fa-check' : 'fa-times'"></i>
                </label>
              </p>
              <span class="md-input">
                    <app-exg-type-ahead-input
                      [listdisplay]="'AnzeigeName'"
                      [searchPlaceholder]="getRessource('SearchVersNe')"
                      [listCall]="'OER_List_CrmRolle_Parent_OETyp'"
                      [pObj]="{ oe_CrmRolle: 9, oe_enmIdent_OETyp: 0,
                              parentOEID: '00000000-0000-0000-0000-000000000000' }"
                      [insertReturnValue]="insertedValuesOEs['aue_oeID_VN']"
                      (choseObj)="changeOE('aue_oeID_VN', $event)"
                      (deleteChosenObj)="deleteOE('aue_oeID_VN')"
                    ></app-exg-type-ahead-input>
                  </span>
              <span class="wf-input">

                <i class="fad fa-magnifying-glass-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                   [tooltip]="getRessource('SearchAdv')" flow="left"
                   (keydown.enter)="searchOEAdvanced('aue_oeID_VN', '00000000-0000-0000-0000-000000000000', 9)"
                   (click)="searchOEAdvanced('aue_oeID_VN', '00000000-0000-0000-0000-000000000000', 9)"></i>
                <i class="fad fa-circle-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                   [tooltip]="getRessource('AddOE')" flow="left"
                   (keydown.enter)="openNewOEModal('aue_oeID_VN', undefined, false)"
                   (click)="openNewOEModal('aue_oeID_VN', undefined, false)"></i>
                </span>
              <!--Schadenort -->
              <p>
                <label class="md-input width-auto">{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenOrt")}}
                  <i class="fa-fw fal" [ngClass]="wf.data.aue_adrID_SchadenOrt !== '00000000-0000-0000-0000-000000000000' ? 'fa-check' : 'fa-times'"></i>
                </label>
              </p>
              <span class="md-input">
                    <app-exg-type-ahead-input
                                               [listdisplay]="'AnzeigeName'"
                                               [listCall]="'OeAddressR_List_AdresseTyp'"
                                               [searchPlaceholder]="'Suche Versicherungsnehmer Adresse'"
                                               [pObj]="{ adr_enmIdent_AdresseTyp: 0,
                                                         oeID: wf.data.aue_oeID_VN }"
                                               [insertReturnValue]="insertedAddresses['aue_adrID_SchadenOrt']"
                                               (choseObj)="changeAddress('aue_adrID_SchadenOrt', $event)"
                                               [isLocked]="wf.data.aue_oeID_VN === '00000000-0000-0000-0000-000000000000'"
                                               (deleteChosenObj)="deleteAdr('aue_adrID_SchadenOrt')"
                    ></app-exg-type-ahead-input>
                  </span>
              <span class="wf-input">
                <i class="fad fa-circle-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                   [tooltip]="'Adresse hinzufügen'" flow="left"
                   (keydown.enter)="openNewAdrModal('aue_adrID_SchadenOrt', wf.data.aue_oeID_VN)"
                   (click)="openNewAdrModal('aue_adrID_SchadenOrt', '00000000-0000-0000-0000-000000000000')"></i>
                </span>

              <!--Schadenort Anspr. anders Switch-->
              <div class="wf-span-layout">
                <exg-checkbox
                  class="md-check-reverse typo-small"
                  tabindex="0"
                  (keydown.enter)="SOAnsprIsDifferent = !SOAnsprIsDifferent"
                  [(ngModel)]="SOAnsprIsDifferent"
                  [caption]="getRessource('SOAnsprDiff')"
                  type="switch">
                </exg-checkbox>
              </div>
              <!--Ansprechpartner Schadenort-->
              <p *ngIf="SOAnsprIsDifferent">
                <label class="md-input width-auto">{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_AnspPtnr")}}
                  <i class="fa-fw fal" [ngClass]="wf.data.aue_oeID_AnspPtnr !== '00000000-0000-0000-0000-000000000000' ? 'fa-check' : 'fa-times'"></i>
                </label>
              </p>
              <span class="md-input"  *ngIf="SOAnsprIsDifferent">
                    <app-exg-type-ahead-input
                      [listdisplay]="'AnzeigeName'"
                      [searchPlaceholder]="getRessource('SearchSOAnspr')"
                      [listCall]="'OER_List_CrmRolle_Parent_OETyp'"
                      [pObj]="{ oe_CrmRolle: 10, oe_enmIdent_OETyp: 2,
                              parentOEID: '00000000-0000-0000-0000-000000000000' }"
                      [insertReturnValue]="insertedValuesOEs['aue_oeID_AnspPtnr']"
                      (choseObj)="changeOE('aue_oeID_AnspPtnr', $event)"
                      (deleteChosenObj)="deleteOE('aue_oeID_AnspPtnr')"
                    ></app-exg-type-ahead-input>
                  </span>
              <span class="wf-input"  *ngIf="SOAnsprIsDifferent">
                <i class="fad fa-magnifying-glass-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                   [tooltip]="getRessource('SearchAdv')" flow="left"
                   (keydown.enter)="searchOEAdvanced('aue_oeID_AnspPtnr', '00000000-0000-0000-0000-000000000000', 10, 2)"
                   (click)="searchOEAdvanced('aue_oeID_AnspPtnr', '00000000-0000-0000-0000-000000000000', 10, 2)"></i>
                <i class="fad fa-circle-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                   [tooltip]="getRessource('AddOE')" flow="left"
                   (keydown.enter)="openNewOEModal('aue_oeID_AnspPtnr', undefined, false)"
                   (click)="openNewOEModal('aue_oeID_AnspPtnr', undefined, false, 10, 2)"></i>
              </span>
            </div>
            <!--Inputs-->
            <div class="grid cols-12">
              <!--Schadendatum datetime-->
              <exg-input [ngModel]="wf.data.aueSchadenDatum"
                         (ngModelChange)="changeDataFromInput('aueSchadenDatum', $event, wf)"
                         [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenDatum')"
                         name="SchadenDatum" class="span-6"
                         type="date" [isEpoch]="true">
              </exg-input>
              <!--Versicherungsart evtl. Mult. Choice-->
              <app-exg-select-enumeration #VCrcptTyp
                                          [value]="wf.data.aue_enmIdent_Versicherungsart"
                                          (valueChange)="changeDataFromInput('aue_enmIdent_Versicherungsart', $event, wf)"
                                          [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')"
                                          enumerationName="Versicherungsart"
                                          class="span-6">
              </app-exg-select-enumeration>
              <!--SchadenArt-->
              <app-exg-select-enumeration [value]="wf.data.aue_enmIdent_SchadenArt"
                                          listDisplay="enmTextA"
                                          (valueChange)="changeDataFromInput('aue_enmIdent_SchadenArt', $event, wf)"
                                          [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')"
                                          enumerationName="Schadenart"
                                          class="span-6">
              </app-exg-select-enumeration>
              <!--SchadenUrsache, abhängig von SchadenArt-->
              <app-exg-select-enumeration [value]="wf.data.aue_enmIdent_SchadenUrsache"
                                          *ngIf="wf.data.aue_enmIdent_SchadenArt"
                                          listDisplay="enmText"
                                          (valueChange)="changeDataFromInput('aue_enmIdent_SchadenUrsache', $event, wf)"
                                          [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenUrsache')"
                                          enumerationName="{{wf.data.aue_enmName_SchadenUrsache}}"
                                          class="span-6">
              </app-exg-select-enumeration>
            </div>
          </div>
        </div>
        <!--Schadendaten 2-->
        <div *ngIf="wfConfig.selectedWorkflowIndex === 4 && workflow[4] as wf" class="content">
          <div class="wf-content" >
            <div class="wf-header">
              <h1>{{wf.headerText}}</h1>
              <p>Tragen Sie hier die relevanten finanziellen Angaben zum Versicherungsfall ein. Dazu gehören die Versicherungssumme oder der Versicherungswert auf Basis des Jahres 1914, der Selbstbehalt sowie die Reserve des Versicherungsunternehmens in Euro.
              </p>
              <p>Zusätzlich können Sie Hinweise zur Entschädigungsgrenze hinterlegen, um den Rahmen der Regulierung klar zu definieren.</p>
            </div>
            <div class="grid cols-12">
              <!--Versicherungssumme ODER Wert 1914 Betrag-->
              <exg-input type="number"  class="span-6"
                         *ngIf="!wf.data.aueWert1914"
                         [step]=1 inputmode="decimal"
                         [max]="1000000000"
                         [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aueVersicherungSumme')+ ' in €'"
                         [(ngModel)]="wf.data.aueVersicherungSumme" name="aueVersicherungSumme"
                         (input)="ngModelWorkaround('aueVersicherungSumme', wf, $event)">
              </exg-input>
              <!--Computed Versicherungssumme-->
              <exg-input type="number"  class="span-6"
                         *ngIf="!!wf.data.aueWert1914"
                         [step]=1 inputmode="decimal"
                         disabled="{{!!wf.data.aueWert1914}}"
                         [max]="1000000000"
                         [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aueVersicherungSumme')+ ' in €'"
                         [(ngModel)]="wf.data.aueVersicherungSumme" name="aueVersicherungSumme">
              </exg-input>
              <!--Wert 1914-->
              <exg-input type="number"  class="span-6"
                         [step]=1 inputmode="decimal"
                         [max]="1000000000"
                         disabled="{{(!!wf.data.aueVersicherungSumme && !wf.data.aueWert1914)}}"
                         [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aueWert1914')+ ' in €'"
                         [(ngModel)]="wf.data.aueWert1914" name="aueWert1914"
                         (input)="ngModelWorkaround('aueWert1914', wf, $event)">>
              </exg-input>
              <!--Selbstbehalt Betrag-->
              <exg-input type="number"  class="span-6"
                         [step]=1 inputmode="decimal"
                         [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aueSelbstbehalt')+ ' in €'"
                         [ngModel]="wf.data.aueSelbstbehalt" name="aueSelbstbehalt"
                         (ngModelChange)="changeDataFromInput('aueSelbstbehalt', $event, wf)">
              </exg-input>
              <!--Reserve Auftraggeber Betrag-->
              <exg-input type="number" class="span-6"
                         [step]=1 inputmode="decimal"
                         [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aueReserveVU')+ ' in €'"
                         [ngModel]="wf.data.aueReserveVU" name="aueReserveVU"
                         (ngModelChange)="changeDataFromInput('aueReserveVU', $event, wf)">
              </exg-input>
              <!--Hinweise Entschädigungsgrenze textarea-->
              <exg-textarea class="span-6" [caption]="enumSvc.getFieldCaption('AuftragE_EIS', 'aueHinweiseEntschaedigungsgrenze')"
                            [ngModel]="wf.data.aueHinweiseEntschaedigungsgrenze" name="aueHinweiseEntschaedigungsgrenze"
                            (ngModelChange)="changeDataFromInput('aueHinweiseEntschaedigungsgrenze', $event, wf)"
              ></exg-textarea>
            </div>
          </div>
        </div>
        <!--WAnspr-->
        <div *ngIf="wfConfig.selectedWorkflowIndex === 5 && workflow[5] as wf" class="content">
          <div class="wf-content">
            <div class="wf-header">
              <h1>{{wf.headerText}}</h1>
              <p>Erfassen Sie hier optional zusätzliche Ansprechpartner, die für den Prozess relevant sind.</p>
              <p>Dies ermöglicht es, wichtige Kontaktpersonen übersichtlich anzulegen und bei Bedarf individuelle Rollen zuzuweisen, um die Kommunikation und Bearbeitung zu erleichtern.</p>
            </div>
            <div class="grid-auto-1-auto" style="position: relative">
              <ng-container *ngFor="let key of WAnsprOEList; let index = index">
                <div class="grid-auto-1">
                  <app-exg-dropdown>
                    <ng-template #hostTemplate>
                      <p class="wf-wanspr-p">
                        <label class="width-auto wf-wanspr-label" [tooltip]="getRessource('SetWAnsprRole')" flow="left">
                          {{ enumSvc.getEnumerationText('WAnsprPtnrFunktion', wf?.data['aue_enmIdent_WAnsprPtnr' + (index + 1) + 'Funktion']) }}
                          <i class="fa-fw fal"
                             [ngClass]="'fa-chevron-down'"></i>
                        </label>
                      </p>
                      <!--<i class="fad fa-pen search-filter-action" style="margin-top: 0;" [tooltip]="getRessource('SetWAnsprRole')" flow="left"></i>-->
                    </ng-template>
                    <ng-template #contentTemplate let-popup>
                      <div style="max-height: 10rem;">
                        <div *ngFor="let row of enumSvc.getEnumerationList('WAnsprPtnrFunktion')">
                          <div
                            (click)="updateWAnsprRoll(key, row.enmIdent); popup.close();"
                            class="list-row list-single-line typo-small wf-cursor-pointer"
                            *ngIf="row"
                          >
                            {{ row.enmText }}
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </app-exg-dropdown>
                </div>
                <span
                  class="md-input"
                  [@slideInOut]="index > 0">
                  <app-exg-type-ahead-input
                    [listdisplay]="'AnzeigeName'"
                    [searchPlaceholder]="getRessource('SearchWAnspr', { WAnspr: enumSvc.getEnumerationText('WAnsprPtnrFunktion', wf?.data['aue_enmIdent_WAnsprPtnr' + (index + 1) + 'Funktion'])})"

                    [listCall]="'OER_List_CrmRolle_Parent_OETyp'"
                    [pObj]="{ oe_CrmRolle: 0, oe_enmIdent_OETyp: 0,
                              parentOEID: '00000000-0000-0000-0000-000000000000' }"
                    [insertReturnValue]="insertedValuesOEs[key]"
                    (choseObj)="changeOE(key, $event)"
                    (deleteChosenObj)="deleteOE(key)"
                  ></app-exg-type-ahead-input>
                </span>
                <span class="wf-input grid-1-auto"
                      [@slideInOut]="index > 0">
                <i class="fad fa-magnifying-glass-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                   [tooltip]="getRessource('SearchAdv')" flow="left"
                   (keydown.enter)="searchOEAdvanced(key, '00000000-0000-0000-0000-000000000000' )"
                   (click)="searchOEAdvanced(key, '00000000-0000-0000-0000-000000000000')"></i>
                  <i class="fad fa-circle-plus search-filter-action" style="margin-top: 0;font-size: medium" tabindex="0"
                     [tooltip]="getRessource('AddOE')" flow="left"
                     (keydown.enter)="openNewOEModal(key, '00000000-0000-0000-0000-000000000000', false)"
                     (click)="openNewOEModal(key, '00000000-0000-0000-0000-000000000000', false)"></i>
                </span>
              </ng-container>
            </div>
          </div>
        </div>
        <!--Zusammenfassung-->
        <div *ngIf="wfConfig.selectedWorkflowIndex === 6 && workflow[6] as wf" class="content">
          <div class="wf-content">
            <div class="grid-1-auto wf-header">
              <h1>{{wf.headerText}}</h1>
              <div style="text-align: center">
                <button tabindex="0"
                        class="md-btn" (click)="save('case')">{{getRessource('FinishCreation')}}&nbsp;<i class="fal fa-check"></i></button>
                <button tabindex="0"
                        [disabled]="!excSecurity.isFeatured('CASECHECK')"
                        class="md-btn" (click)="save('caseAndCheck')">{{getRessource('FinishAndDoCheck')}}&nbsp;<i class="fal fa-check"></i></button>
              </div>
            </div>
            <div class="">
              <p class="typo-small grid-auto-1" style="margin-left: 1rem" *ngFor="let entry of wfConfig.wfDataAsArray">
                <!--Wanspr-->
                <label *ngIf="entry.key.startsWith('aue_enmIdent_WAnsprPtnr')
                           && insertedValuesOEs[getCorrespondingOeID(entry.key)]">
                  {{enumSvc.getEnumerationText('WAnsprPtnrFunktion', entry.value) }}:
                </label>
                <span *ngIf="entry.key.startsWith('aue_enmIdent_WAnsprPtnr')
                          && insertedValuesOEs[getCorrespondingOeID(entry.key)]"
                      class="width-auto">
                  {{(insertedValuesOEs[getCorrespondingOeID(entry.key)].AnzeigeName || getRessource('NotAssigned')) }}
                </span>
                <!--EnumIdent SchadenUrsache-->
                <label *ngIf="entry.key === 'aue_enmIdent_SchadenUrsache'
                            && this.workflow[3].data.aue_enmName_SchadenUrsache">
                  {{ enumSvc.getFieldCaption('AuftragE_EIS', entry.key)}}:
                </label>
                <span *ngIf="entry.key === 'aue_enmIdent_SchadenUrsache'
                            && this.workflow[3].data.aue_enmName_SchadenUrsache"
                      class="width-auto"> {{ (enumSvc.getEnumerationText(this.workflow[3].data.aue_enmName_SchadenUrsache, entry.value)) }}</span>
                <!--SEMI-REQUIRED EnumIdent Auftragtyp-->
                <label *ngIf="entry.key === 'au_enmIdent_AuftragTyp'"
                       [ngStyle]="{'color': entry.value === 0 ? 'var(--c-yellow-400)' : undefined}">
                  {{ enumSvc.getFieldCaption('Auftrag', entry.key)}}:
                </label>
                <span *ngIf="entry.key === 'au_enmIdent_AuftragTyp'"
                      [ngStyle]="{'color': entry.value === 0 ? 'var(--c-yellow-400)' : undefined}"
                      class="width-auto"> {{ (enumSvc.getEnumerationText('AuftragTyp', entry.value)) }}</span>

                <!--SEMI-REQUIRED aue_enmIdent_Versicherungsart aue_enmIdent_SchadenArt aue_enmIdent_AuftragTyp-->
                <label *ngIf="['aue_enmIdent_Versicherungsart', 'aue_enmIdent_SchadenArt'].includes(entry.key)"
                       [ngStyle]="{'color': entry.value === 0 ? 'var(--c-yellow-400)' : undefined}">
                  {{ enumSvc.getFieldCaption('AuftragE_EIS', entry.key)}}:
                </label>
                <span *ngIf="['aue_enmIdent_Versicherungsart', 'aue_enmIdent_SchadenArt'].includes(entry.key)"
                      [ngStyle]="{'color': entry.value === 0? 'var(--c-yellow-400)' : undefined}"
                      class="width-auto">
                  {{(enumSvc.getEnumerationText(entry.key === 'aue_enmIdent_Versicherungsart' ? 'Versicherungsart' : 'Schadenart', entry.value))}}</span>
                <!--SEMI-REQUIRED Multiple Choice Leistungsgegenstand-->
                <label *ngIf="entry.key.includes('aueLeistungsgegenstand')"
                       [ngStyle]="{'color': !entry.value ? 'var(--c-yellow-400)' : undefined}">
                  {{ enumSvc.getFieldCaption('AuftragE_EIS', entry.key)}}:
                </label>
                <span *ngIf="entry.key.includes('aueLeistungsgegenstand')" class="width-auto"
                      [ngStyle]="{'color': !entry.value ? 'var(--c-yellow-400)' : undefined}">
                      {{ (getLeistungsgegenstandUIString(entry.value)) }}
                </span>
                <!--REQUIRED au_oeID_Auftraggeber-->
                <label *ngIf="entry.key.includes('au_oeID_Auftraggeber')"
                       [ngStyle]="{'color': entry.value === '00000000-0000-0000-0000-000000000000' ? 'var(--c-red-400)' : undefined}">
                  {{enumSvc.getFieldCaption('Auftrag', entry.key) }}:
                </label>
                <span *ngIf="entry.key.includes('au_oeID_Auftraggeber')"
                      [ngStyle]="{'color': entry.value === '00000000-0000-0000-0000-000000000000' ? 'var(--c-red-400)' : undefined}"
                      class="width-auto">
                  {{ entry.value === '00000000-0000-0000-0000-000000000000' ? getRessource('NotAssigned') : insertedValuesOEs[entry.key].AnzeigeName }}
                </span>
                <!--SEMI-REQUIRED aue_oeID_Versicherung aue_oeID_VN-->
                <label *ngIf="entry.key === 'aue_oeID_Versicherung'
                           || entry.key.includes('aue_oeID_VN')"
                       [ngStyle]="{'color': entry.value === '00000000-0000-0000-0000-000000000000' ? 'var(--c-yellow-400)' : undefined}">
                  {{enumSvc.getFieldCaption('AuftragE_EIS', entry.key)}}:
                </label>
                <span *ngIf="entry.key === 'aue_oeID_Versicherung'
                           || entry.key.includes('aue_oeID_VN')"
                      [ngStyle]="{'color': entry.value === '00000000-0000-0000-0000-000000000000' ? 'var(--c-yellow-400)' : undefined}"
                      class="width-auto">
                  {{ entry.value === '00000000-0000-0000-0000-000000000000' ? getRessource('NotAssigned') : insertedValuesOEs[entry.key].AnzeigeName }}
                </span>
                <!--OEs, nicht WAnspr, nicht required-->
                <label *ngIf="entry.key.toLowerCase().includes('oeid')
                          && !entry.key.includes('WAnspr')
                          && !entry.key.includes('au_oeID_Auftraggeber')
                          && !entry.key.includes('aue_oeID_Versicherung')
                          && !entry.key.includes('aue_oeID_VN')
                          && entry.key !== 'aue_oeID_Versicherung'">
                  {{ entry.key.startsWith('aue') ? enumSvc.getFieldCaption('AuftragE_EIS', entry.key) : enumSvc.getFieldCaption('Auftrag', entry.key) }}:
                </label>
                <span *ngIf="entry.key.toLowerCase().includes('oeid')
                         && !entry.key.includes('WAnspr')
                         && !entry.key.includes('au_oeID_Auftraggeber')
                         && !entry.key.includes('aue_oeID_Versicherung')
                         && !entry.key.includes('aue_oeID_VN')
                         && entry.key !== 'aue_oeID_Versicherung'"
                      class="width-auto">
                  {{ entry.value === '00000000-0000-0000-0000-000000000000' ? getRessource('NotAssigned') : insertedValuesOEs[entry.key].AnzeigeName }}
                </span>
                <!--SEMI-REQURIED Schadenort-->
                <label *ngIf="entry.key.toLowerCase().includes('schadenort')"
                       [ngStyle]="{'color': entry.value === '00000000-0000-0000-0000-000000000000' ? 'var(--c-yellow-400)' : undefined}">
                  {{ entry.key.startsWith('aue') ? enumSvc.getFieldCaption('AuftragE_EIS', entry.key) : enumSvc.getFieldCaption('Auftrag', entry.key) }}:
                </label>
                <span *ngIf="entry.key.toLowerCase().includes('schadenort')"
                      [ngStyle]="{'color': entry.value === '00000000-0000-0000-0000-000000000000' ? 'var(--c-yellow-400)' : undefined}"
                      class="width-auto">
                  {{ entry.value === '00000000-0000-0000-0000-000000000000' ? getRessource('NotAssigned') : insertedAddresses[entry.key].AnzeigeName }}
                </span>
                <!--SEMI REQUIRED auBeschreibung-->
                <label  *ngIf="entry.key.includes('auBeschreibung')"
                        [ngStyle]="{'color': !entry.value ? 'var(--c-yellow-400)' : undefined}">
                  {{enumSvc.getFieldCaption('Auftrag', entry.key) }}:
                </label>
                <span style="white-space: normal"  *ngIf="entry.key.includes('auBeschreibung')"
                      [ngStyle]="{'color': !entry.value ? 'var(--c-yellow-400)' : undefined}">{{(entry.value)}}</span>
                <!--TextAreas-->
                <label *ngIf="entry.key.includes('aueHinweiseEntschaedigungsgrenze')">
                  {{enumSvc.getFieldCaption('AuftragE_EIS', entry.key) }}:
                </label>
                <span style="white-space: normal" *ngIf="entry.key.includes('aueHinweiseEntschaedigungsgrenze')">{{(entry.value)}}</span>
                <!--SEMI-REQUIRED Schadendatum & Auftragsdatum-->
                <label *ngIf="entry.key === 'aueSchadenDatum' || entry.key === 'aueAuftragsdatum'"
                       [ngStyle]="{'color': !entry.value ? 'var(--c-yellow-400)' : undefined}">
                  {{ entry.key.startsWith('aue') ? enumSvc.getFieldCaption('AuftragE_EIS', entry.key) : enumSvc.getFieldCaption('Auftrag', entry.key) }}:
                </label>
                <span style="white-space: normal"
                      *ngIf="entry.key === 'aueSchadenDatum' || entry.key === 'aueAuftragsdatum'"
                      [ngStyle]="{'color': !entry.value ? 'var(--c-yellow-400)' : undefined}"
                >{{(entry.value | excDate: getGlobal('DateFormat'))}}</span>
                <!--REQUIRED aueSchadenNr-->
                <label *ngIf="entry.key.includes('aueSchadenNr')"
                       [ngStyle]="{'color': !entry.value ? 'var(--c-red-400)' : undefined}">
                  {{ enumSvc.getFieldCaption('AuftragE_EIS', entry.key)}}:
                </label>
                <span *ngIf="entry.key.includes('aueSchadenNr')"
                      [ngStyle]="{'color': !entry.value ? 'var(--c-red-400)' : undefined}"
                      class="width-auto"> {{ (entry.value) }}</span>
                <!--SEMI-REQUIRED auOKZ-->
                <label *ngIf="entry.key.includes('auOKZ')"
                       [ngStyle]="{'color': !entry.value ? 'var(--c-yellow-400)' : undefined}">
                  {{ enumSvc.getFieldCaption('Auftrag', entry.key)}}:
                </label>
                <span *ngIf="entry.key.includes('auOKZ')"
                      [ngStyle]="{'color': !entry.value ? 'var(--c-yellow-400)' : undefined}"
                      class="width-auto"> {{ (entry.value) }}</span>
                <!--Rest-->
                <label *ngIf="!entry.key.toLowerCase().includes('oeid')
                           && !entry.key.includes('WAnspr')
                           && !entry.key.includes('aueLeistungsgegenstand')
                           && !entry.key.includes('auBeschreibung')
                           && !entry.key.includes('aueHinweiseEntschaedigungsgrenze')
                           && !entry.key.includes('adrID')
                           && !entry.key.includes('aueSchadenDatum')
                           && !entry.key.includes('aueAuftragsdatum')
                           && !entry.key.includes('aue_enmIdent_Versicherungsart')
                           && !entry.key.includes('aue_enmIdent_SchadenArt')
                           && !entry.key.includes('aue_enmIdent_SchadenUrsache')
                           && !entry.key.includes('enmName')
                           && !entry.key.includes('aueSchadenNr')
                           && !entry.key.includes('auOKZ')
                           && !entry.key.includes('au_enmIdent_AuftragTyp')">
                  {{ entry.key.startsWith('aue') ? enumSvc.getFieldCaption('AuftragE_EIS', entry.key) : enumSvc.getFieldCaption('Auftrag', entry.key) }}:
                </label>
                <span *ngIf="!entry.key.toLowerCase().includes('oeid')
                          && !entry.key.includes('WAnspr')
                          && !entry.key.includes('aueLeistungsgegenstand')
                          && !entry.key.includes('auBeschreibung')
                          && !entry.key.includes('aueHinweiseEntschaedigungsgrenze')
                          && !entry.key.includes('adrID')
                          && !entry.key.includes('aueSchadenDatum')
                          && !entry.key.includes('aueAuftragsdatum')
                          && !entry.key.includes('aue_enmIdent_Versicherungsart')
                          && !entry.key.includes('aue_enmIdent_SchadenArt')
                          && !entry.key.includes('aue_enmIdent_SchadenUrsache')
                          && !entry.key.includes('enmName')
                          && !entry.key.includes('aueSchadenNr')
                          && !entry.key.includes('auOKZ')
                          && !entry.key.includes('au_enmIdent_AuftragTyp')"
                      class="width-auto"> {{ (entry.value) }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="spawn">
          <button *ngIf="wfConfig.selectedWorkflowIndex !== 0"
                  tabindex="0"
                  class="md-btn wf-btn-back" (click)="navigateLeft()"><i class="fal fa-arrow-left"></i>&nbsp;{{getRessource('Back')}}</button>
          <button *ngIf="wfConfig.selectedWorkflowIndex !== 6"
                  tabindex="0"
                  class="md-btn wf-btn-next" (click)="navigateRight()">{{getRessource('Next')}}&nbsp;<i class="fal fa-arrow-right"></i></button>
        </div>
      </div>
      <!--Media Drop Zone-->
      <div class="content md3-card-on-surface layout-auto-1" style="width: 500px">
        <h6>
          <span>{{getRessource('Attachments')}}</span>
          <i class="md-btn-circular fal fa-upload"
             [tooltip]="getRessource('UploadAtt')" flow="left" style="font-size: medium"
             *ngIf="!!this.Data.auID"
             (click)="openDocumentUploadModal()"></i>
        </h6>
        <!--SaveFirst View-->
        <div *ngIf="!Data.auID" class="grid-auto-1 wf-save-first">
          <div style="text-align: center;">
            <i class="fas fa-exclamation-triangle fa-2xl" style="margin-bottom: 2rem"></i>
            <div style="margin: 0 1rem">{{getRessource('SaveFirst')}}</div>
          </div>
        </div>
        <!--SavedView View-->
        <div class="content" *ngIf="Data.auID">
          <!--Saved Folder View-->
          <cdk-tree *ngIf="attachmentJagTable.state === 0"
                    [dataSource]="CaseSummary?.attachmentJagTable.data"
                    [treeControl]="attConfig.treeControl">
            <cdk-nested-tree-node *cdkTreeNodeDef="let node" class="example-tree-node">
              <div class="list-row app-document-list-row">
                <div class="grid-auto-1">
                  <div  class="list-avatar-placeholder wf-cursor-pointer">
                    <img src="{{excRest.computeUrl('ImageThumbnail',{dokID: node.dokID})}}"
                         [tooltip]="getRessource('Preview')" flow="left" style="font-size: medium"
                         (click)="openFilePreview(node.dokID)" alt=""
                         class="list-avatar-placeholder"/>
                  </div>
                  <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
                    <div class="list-metadata" style="margin-left:0">
                      <div>
                        <ng-container *ngIf="node.linked">
														<span flow="left" style="font-size: medium"
                                  [tooltip]="getRessource('tooltip.linked')">
															<i class="fal fa-link"></i>
															<ng-container *ngIf="!node.dokTrackingPortalShare">
																&nbsp;-&nbsp;
															</ng-container>
														</span>
                        </ng-container>
                        <ng-container *ngIf="node.dokTrackingPortalShare">
                          <i class="far fa-cloud"></i>
                          -
                        </ng-container>
                        {{appSvc.file.calcFileSize(node.dokGroesse, false)}}
                        - {{node.dokMode}}</div>
                    </div>
                    <div class="list-metadata ">
                      <div
                        class="typo-right">{{node.dokLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
                      <div class="typo-right">{{node.dokCRU}}</div>
                    </div>
                    <div class="span-2">
                      <div class="grid-1-auto">
                        <div class="wf-doc-item">
                          <strong>{{node.dokName}}{{node.dokErw}}</strong></div>
                        <div class="typo-right app-space-top_1">
                          <span
                            [tooltip]="getRessource('tooltip.openInBrowser')" flow="left" style="font-size: medium">
                          <i class="search-action fa-duotone fa-eye" style="margin-bottom: .5rem"
                             (click)="openAttachmentInBrowser(node)"></i></span>
                          <span
                            [tooltip]="getRessource('tooltip.download')" flow="left" style="font-size: medium">
                          <i class="search-action fa-duotone fa-download" style="margin-bottom: .5rem"
                             (click)="downloadAttachment(node.dokID)"></i></span>
                          <span
                            [tooltip]="getRessource('tooltip.PDFSplitting')" flow="left" style="font-size: medium">
                          <i class="search-action fa-file-pdf" style="margin-bottom: .5rem"
                             [class.fa-duotone]="node.dokName.toUpperCase().endsWith('.PDF')"
                             [class.fa-regular]="!node.dokName.toUpperCase().endsWith('.PDF')"
                             [class.disabled]="!node.dokName.toUpperCase().endsWith('.PDF')"
                             (click)="showPDFEditorOverlay(node.dokID, node.dokName.toUpperCase().endsWith('.PDF'))">
                          </i></span>
                          <span
                            [tooltip]="getRessource('tooltip.edit')" flow="left" style="font-size: medium">
                          <i class="search-action fa-duotone fa-pencil-alt" style="margin-bottom: .5rem"
                             (click)="showAttachmentUpdateModal(node.dokID)"></i></span>
                          <span
                            [tooltip]="getRessource('tooltip.toReceipt')" flow="left" style="font-size: medium">
                          <i class="search-action fa-regular fa-file-invoice-dollar disabled" style="margin-bottom: .5rem"
                             (click)="addAttachmentToReceipts()">
                          </i></span>
                          <span
                            [tooltip]="getRessource('tooltip.delete')" flow="left" style="font-size: medium">
                          <i class="search-action fa-trash-alt" style="margin-bottom: .5rem"
                             [class.fa-duotone]="(node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1"
                             [class.fa-regular]="!((node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1)"
                             [class.disabled]="!((node.dokCRL === this.excSecurity.UserLogin && this.userType === 2) || this.userType === 1)"
                             (click)="deleteAttachment(node)">
                          </i></span>
                        </div>
                      </div>
                    </div>
                    <div class="span-2 list-secondary-text">{{node.dokBeschreibung}}</div>
                  </div>
                </div>
              </div>
            </cdk-nested-tree-node>
            <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: attachmentJagTable.hasChild"
                                  class="example-tree-node">
              <div class="list-row" cdkTreeNodeToggle>
                <div class="grid-auto-1" style="padding:0.5rem">
                  <div  class="list-avatar nobackground wf-cursor-pointer">
                    <i class="far fa-fw"
                       [tooltip]="attConfig.treeControl.isExpanded(node) ? getRessource('CloseFolder') : getRessource('OpenFolder')" flow="left" style="font-size: medium"
                       [ngClass]="{'fa-folder-open': attConfig.treeControl.isExpanded(node),'fa-folder':!attConfig.treeControl.isExpanded(node)}"
                    ></i></div>
                  <div class="layout-auto-1">
                    <div class="list-metadata" style="margin-left:0">{{node.dokFolderCount}} {{getRessource('Attachments')}}</div>
                    <div>{{enumSvc.getEnumerationText('DokTyp', node.dok_enmIdent_DokTyp)}}</div>
                  </div>
                </div>
              </div>
              <div [hidden]="!attConfig.treeControl.isExpanded(node)">
                <ng-container cdkTreeNodeOutlet></ng-container>
              </div>
            </cdk-nested-tree-node>
          </cdk-tree>

          <!--DROPZONE-->
          <div (filesSelect)="onFilesSelect($event)"
               (filesSelectChunked)="onFilesSelectChunked($event)"
               [multiple]="true"
               [dnd]="true"
               style="max-height: 200px"
               class="app-drag-drop" appExgDirectUploadV2>
            {{getRessource('DropAtt')}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="wfConfig.isLoading" class="content md3-card-on-surface">
    <div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div>
  </div>
  <!--Sidebar-->
  <div class="app-drawer content md3-card-on-surface"
       *ngIf="!wfConfig.isLoading">
    <i class="app-drawer-icon fal fa-save"
       [tooltip]="getRessource('SaveDraft')" flow="left"
       [class.c-green]="!!Data.auID && !!Data.auUPT && wfConfig.isSavedVersion" (click)="save('draft')"></i>
  </div>
</div>
